import React from "react";
import editIcon from "../../../assets/images/edit-dark.svg";
import addIcon from "../../../assets/images/add-colored.svg";

interface InfoItemProps {
  label: string;
  value: string;
  editable?: boolean;
}

const InfoItem: React.FC<InfoItemProps> = ({ label, value, editable }) => {
  return (
    <div className="flex gap-4 justify-between items-start w-full">
      <div className="flex flex-col flex-1 shrink basis-0 text-left">
        <div className="text-sm leading-loose text-gray-500">{label}</div>
        <div className="mt-1 text-base font-semibold text-gray-800">
          {value}
        </div>
      </div>
      {/* {editable ? (
        <div className="flex gap-0.5 items-center text-sm font-medium leading-loose text-indigo-600 whitespace-nowrap">
          <img
            loading="lazy"
            src={addIcon}
            className="object-contain shrink-0 self-stretch my-auto aspect-square w-[18px]"
            alt=""
          />
          <div className="self-stretch my-auto">Add</div>
        </div>
      ) : (
        <img
          loading="lazy"
          src={editIcon}
          className="object-contain shrink-0 w-6 aspect-square"
          alt=""
        />
      )} */}
    </div>
  );
};

const InfoSection: React.FC<any> = ({ info }) => {
  return (
    <section className="flex overflow-hidden flex-col items-start p-4 mt-4 w-full bg-white rounded-3xl border border-gray-200 border-solid shadow-sm">
      <InfoItem label="Patient's Mobile Number" value={info?.contact_no} />
      <InfoItem
        label="Patient's DOB"
        value={info?.dob && info?.dob !== "0000-00-00" ? info?.dob : "-NA-"}
      />
      <InfoItem label="Patient's Email Address" value={info?.email || "-NA-"} />
    </section>
  );
};

export default InfoSection;
